import React from "react";
import { Typography, Box, Button, Grid, Card, List, ListItem, ListItemText } from "@mui/material";
import TriangleBackground from "../layout/TriangleBackground";
import LogoIcon from "../../assets/logo.png"; // your logo
import Slider from "react-slick"; // make sure to install react-slick and slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { TextField, MenuItem, Modal, Fade, Backdrop } from "@mui/material";
import { useState } from "react";


// Example icons
import WebIcon from "@mui/icons-material/Web";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CloudIcon from "@mui/icons-material/Cloud";
import StorageIcon from "@mui/icons-material/Storage";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import careerimge from "../../assets/images/careerimg.jpeg";
const Contact = ({ mode }) => {
    const DColors = ["#FF69B4", "#35ca35", "#FFA500", "#00BFFF"]; // pink, green, orange, blue


    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        service: "",
        description: "",
    });

    const [modalOpen, setModalOpen] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [phoneError, setPhoneError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "email") {
            const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            setEmailError(valid ? "" : "Please enter a valid email address");
        }

        if (name === "phone") {
            const valid = /^\+\d{10,15}$/.test(value);
            setPhoneError(valid ? "" : "Please enter a valid phone number with country code");
        }

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate before submit
        if (emailError || phoneError) return;

        const jsonData = {
            ...form,
        };

        console.log("Form Submitted:", JSON.stringify(jsonData, null, 2));

        // Clear form
        setForm({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            service: "",
            description: "",
        });

        // Show modal
        setModalOpen(true);
    };


    const textSegments = [
        { letter: "L", color: DColors[0] },
        { text: "ET'S " },
        { letter: "G", color: DColors[1] },
        { text: "ET " },
        { letter: "T", color: DColors[2] },
        { text: "alking " }
    ];

    // Example services array
    const services = [
        {
            title: "Web Development",
        },
        {
            title: "Mobile Development",
        },
        {
            title: "Cloud Computing",
        },
        {
            title: "CDN Solutions",
        },
        {
            title: "Middleware"
        },
        {
            title: "Gen AI",
        },
        {
            title: "Innovation Tech"
        },
        {
            title: "Enterprise App Development"
        },
    ];

    
    // Slider settings
    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 900, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }, // Add more granular breakpoint for smaller devices
        ],
    };


    return (
        <div>
            {/* === Hero Section with Triangle Background === */}
            <TriangleBackground mode={mode}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        justifyContent: "center",
                        px: 2,
                        gap: 4,
                        height: "100%",
                    }}
                >
                    {/* Content on the left */}
                    <Box
                        sx={{
                            width: { xs: "100%", md: "50%" },
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >

                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: "bold",
                                mb: 2,
                                color: mode === "dark" ? "#fff" : "#000",
                            }}
                        >
                            {textSegments.map((seg, idx) =>
                                seg.letter ? (
                                    <span key={idx} style={{ color: seg.color }}>
                                        {seg.letter}
                                    </span>
                                ) : (
                                    <span key={idx}>{seg.text}</span>
                                )
                            )}
                        </Typography>
                        <Typography
                            variant="h4"

                            sx={{ color: mode === "dark" ? "#ccc" : "#444", mb: 4 }}
                        >
                            We are ready for our next challenge. Reach out to us.
                        </Typography>

                        <Typography
                            variant="h6"
                            className="fade-slide-text"
                            sx={{ color: mode === "dark" ? "#ccc" : "#444" }}
                        >
                            One Stop Solution for Technology
                        </Typography>
                    </Box>

                    {/* Logo on the right */}
                    <Box
                        component="img"
                        src={LogoIcon}
                        alt="Olyviatech Logo"
                        className="spin-fade-logo"
                        sx={{
                            width: { xs: 120, sm: 150, md: 250, opacity: 0.5 },
                            height: "auto",
                        }}
                    />
                </Box>
            </TriangleBackground>

            <Box
                component="section"
                sx={{
                    position: "relative",
                    width: "100%",
                    py: { xs: 8, md: 12 },
                    px: 2,
                    background: "linear-gradient(135deg, #e3ecf9, #f7faff)", // Elegant background
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                {/* === Watermark Logo Background === */}
                <Box
                    component="img"
                    src={LogoIcon}
                    alt="Background Logo"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "20%",
                        width: { xs: 200, sm: 300, md: 600 },
                        opacity: 0.5,
                        transform: "translate(-50%, -50%)",
                        zIndex: 0,
                    }}
                />

                {/* === Form Content === */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        maxWidth: "800px",
                        width: "100%",
                        background: "rgba(255, 255, 255, 0.75)",
                        backdropFilter: "blur(10px)",
                        borderRadius: 4,
                        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                        p: { xs: 4, md: 6 },
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{ fontWeight: "bold", textAlign: "center", mb: 2 }}
                    >
                        Contact Us
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ textAlign: "center", color: "#444", mb: 4 }}
                    >
                        Let’s work together to build something amazing.
                    </Typography>

                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                            width: "100%",
                        }}
                    >
                        <TextField
                            fullWidth
                            label="First Name"
                            name="firstName"
                            value={form.firstName}
                            onChange={handleChange}
                            required
                        />
                        <TextField
                            fullWidth
                            label="Last Name"
                            name="lastName"
                            value={form.lastName}
                            onChange={handleChange}
                            required
                        />
                        <TextField
                            fullWidth
                            label="Email"
                            name="email"
                            type="email"
                            value={form.email}
                            onChange={handleChange}
                            required
                            error={!!emailError}
                            helperText={emailError}
                        />
                        <TextField
                            fullWidth
                            label="Phone Number (with country code)"
                            name="phone"
                            value={form.phone}
                            onChange={handleChange}
                            required
                            error={!!phoneError}
                            helperText={phoneError}
                        />
                        <TextField
                            select
                            fullWidth
                            label="Service"
                            name="service"
                            value={form.service}
                            onChange={handleChange}
                            required
                        >
                            {services.map((s, idx) => (
                                <MenuItem key={idx} value={s.title}>
                                    {s.title}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            fullWidth
                            label="Description"
                            name="description"
                            value={form.description}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            required
                        />
                        <Box sx={{ textAlign: "center", mt: 2 }}>
                            <Button type="submit" variant="contained" size="large">
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </Box>

                {/* Success Modal */}
                <Modal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{ timeout: 500 }}
                >
                    <Fade in={modalOpen}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "background.paper",
                                borderRadius: 2,
                                boxShadow: 24,
                                p: 4,
                                maxWidth: 400,
                                textAlign: "center",
                            }}
                        >
                            <Typography variant="h6" sx={{ mb: 2 }}>
                                Form submitted successfully
                            </Typography>
                            <Typography variant="body1">
                                We will reach you out in 24 hrs.
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{ mt: 3 }}
                                onClick={() => setModalOpen(false)}
                            >
                                Close
                            </Button>
                        </Box>
                    </Fade>
                </Modal>
            </Box>






            {/* <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Careers
        </Typography>
        <Typography variant="body1">[ Add careers info here ]</Typography>
      </section>

      <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Contact Us
        </Typography>
        <Typography variant="body1">[ Add contact form here ]</Typography>
      </section> */}
        </div>
    );
};

export default Contact;
